<template>
  <!-- D: 모달은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다 -->
  <div id="CYB_PC_UT_02_03" class="modal type-mo-full" data-popup>
    <div class="dialog type-non-footer">
      <header class="dialog-header">
        <h2 class="dialog-title only-pc">우편번호 찾기</h2>
        <button type="button" class="dialog-close" data-popup-close>
          <span class="c-icon icon-large-x"></span>
          <span class="sr-only">팝업 닫기</span>
        </button>
      </header>

      <div class="dialog-content">
        <div class="dialog-content-inner">
          <!-- D: MO에서만 존재 -->
          <h3 class="c-title-level3 only-mo">우편번호 찾기</h3>
          <!-- // D: MO에서만 존재 -->
          <!-- D: KAKAO 주소검색 API 아래 div.adress-api-wrap 안에 넣어주세요. -->
          <div class="adress-api-wrap">KAKAO 주소검색 API</div>
          <!-- // D: KAKAO 주소검색 API 아래 div.adress-api-wrap 안에 넣어주세요. -->
        </div>
      </div>
    </div>
    <!-- D: dimmed -->
    <div class="dimmed"></div>
  </div>
</template>
<script setup name="zipFindPop"></script>
